import React from "react";

import Project from "./project";

import INFO from "../../data/user";

import "./styles/allProjects.css";

const AllProjects = () => {
	const projects = [...INFO.projects].reverse();
	return (
		<div className="all-projects-container">
			{projects.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						title={project.title}
						description={project.description}
						githubLink={project.githubLink}
						liveLink={project.liveLink}
						technologies={project.technologies}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;